import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARPRAPOSEDMITAC_SOURCE_ID = 'miramarPraposedMITACSource';

const source = {
  id: MIRAMARPRAPOSEDMITAC_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.MITAC_Proposed_Developments_Parcel`,
};

export default source;
